import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellation-en',
  templateUrl: './cancellation-en.component.html',
  styleUrls: ['./cancellation-en.component.css']
})
export class CancellationEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
